export default __webpack_public_path__ + "static/media/team-until-00000000.f9e611bb.jpeg";